import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  standalone: false,
  selector: "app-sign-up-modal",
  templateUrl: "./sign-up-modal.component.html",
  styleUrls: ["./sign-up-modal.component.scss"],
})
export class SignUpModalComponent implements OnInit {
  @Input() errorMessage: string;
  @Input() userName: string;
  memberId: number;

  constructor(private router: Router, public activeModal: NgbActiveModal) {}

  ngOnInit(): void {}

  navigateToLoginPage(): void {
    this.activeModal.close();
    this.router.navigate(["/login"], { queryParams: { contestMemberId: this.memberId }});
  }

  navigateToSignUpPage(): void {
    this.activeModal.close();
    this.router.navigate(["/login"], { queryParams: { toggleRegister: true, ...(this.memberId ? { contestMemberId: this.memberId } : {}) }});
  }

  dismissModal(): void {
    this.activeModal.close();
  }
}
